/**
 * A level bar that reads a meter every animation frame and writes the DOM
 * directly: the screen around it never re-renders for a level.
 */
import { useEffect, useRef } from "react";

import "./voice.css";

export function Level({ read, label }: { read: () => number; label: string }) {
  const bar = useRef<HTMLElement>(null);
  const fn = useRef(read);
  fn.current = read;
  useEffect(() => {
    let raf = 0;
    let shown = 0;
    const tick = () => {
      const v = fn.current();
      shown = v > shown ? v : shown * 0.85 + v * 0.15; // fast attack, slow fall
      if (bar.current) bar.current.style.transform = `scaleX(${shown.toFixed(3)})`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return (
    <span className="vlevel" role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={1}>
      <i ref={bar} />
    </span>
  );
}
